import { render, staticRenderFns } from "./relationship.vue?vue&type=template&id=036ff054&scoped=true&"
import script from "./relationship.vue?vue&type=script&lang=js&"
export * from "./relationship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ff054",
  null
  
)

export default component.exports